import { createLoader } from '@meteor/data-hooks';
import { withAuth } from '../../user';
import { organizationClient } from '../client';

export let organizationInviteAcceptLoader = createLoader({
  name: 'organizationInviteAccept',
  fetch: (i: { inviteKey: string }) =>
    withAuth(() => organizationClient.organizationInviteAccept.get(i)),
  mutators: {
    accept: (i: void, { input: { inviteKey } }) =>
      withAuth(() =>
        organizationClient.organizationInviteAccept.accept({
          inviteKey
        })
      ),

    reject: (i: void, { input: { inviteKey } }) =>
      withAuth(() =>
        organizationClient.organizationInviteAccept.reject({
          inviteKey
        })
      )
  }
});

export let useOrganizationInviteAccept = (inviteKey: string | null) => {
  let invite = organizationInviteAcceptLoader.use(inviteKey ? { inviteKey } : null);

  return {
    ...invite,
    acceptMutator: invite.useMutator('accept'),
    rejectMutator: invite.useMutator('reject')
  };
};
